<template>
  <b-card class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <OfferSearchResults
          :searchResults="searchResults"
          @edit="edit"
          @approve="approveOffer"
          @publish="publishOffer"
          @request-approval="requestApprovalOffer"
          @view-active="viewActiveOffer"
          @cancel-update="cancelUpdateOffer"
          :busy="isBusy"
          :isAdmin="isInRole('RTPSDataAdmin')"
          :isApprover="isInRole('RTPSDataApprover')"
        ></OfferSearchResults>
      </b-col>
    </b-row>
    <b-row v-if="isInRole('RTPSDataAdmin')">
      <b-col cols="1" sm="2" offset="10" offset-sm="8">
        <b-button variant="secondary" block @click="add('patient_pay')">Add Patient Pay Offer</b-button>
      </b-col>
      <b-col cols="1" sm="2">
        <b-button variant="secondary" block @click="add('days_supply')">Add Days Supply Offer</b-button>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
  import { mapGetters, mapState } from "vuex";
  import router from "@/router";
  import {
    OFFER_SEARCH,
    OFFER_REQUESTAPPROVAL,
    OFFER_APPROVE,
    OFFER_PUBLISH,
    OFFER_CANCEL
  } from "@/store/offer/actions.type";
  import OfferSearchResults from "@/components/OfferSearchResults";

  export default {
    name: "OfferList",
    components: {
      OfferSearchResults
    },
    data() {
      return {
        currentPage: 1,
        size: 20,
        criteria: {},
        sortBy: "offer_effective_date",
        sortDesc: true
      };
    },
    computed: {
      ...mapGetters({
        groups: "groups"
      }),
      ...mapState({
        searchResults: state => state.offer.searchResults,
        isBusy: state => state.offer.isBusy
      })
    },
    methods: {
      isInRole(role) {
        return this.groups.indexOf(role) > -1;
      },
      add(offerType) {
        router.push({
          name: "offer-item",
          params: {
            offer_type_text: offerType
          }
        });
      },
      edit(data) {
        console.log(data);
      },
      requestApprovalOffer(offer) {
        if (!this.isBusy) {
          this.$store.dispatch(OFFER_REQUESTAPPROVAL, offer);
        }
      },
      approveOffer(offer) {
        if (!this.isBusy) {
          this.$store.dispatch(OFFER_APPROVE, offer);
        }
      },
      publishOffer(offer) {
        if (!this.isBusy) {
          this.$store.dispatch(OFFER_PUBLISH, offer);
        }
      },
      cancelUpdateOffer(offer) {
        if (!this.isBusy) {
          this.$store.dispatch(OFFER_CANCEL, offer);
        }
      },
      viewActiveOffer(offer) {
        if (!this.isBusy) {
          router.push({
            name: "offer-item",
            params: {
              viewActive: true,
              copay_offer_id: offer.copay_offer_id
            }
          });
        }
      }
    },
    created() {
      this.$store.dispatch(OFFER_SEARCH);
    }
  };
</script>



// WEBPACK FOOTER //
// src/views/OfferList.vue